// ─────────────────────────────────────────────────────────────────────────
// embed.ts — CDN bundle entry. Self-registers <solar-calculator> on load and
// exposes window.SolarCalculator for no-build sites (GHL, WordPress, static):
//
//   <script src="https://solar-calc.sellmyservice.com.au/embed.js" defer></script>
//   <script>SolarCalculator.configure({ client: { clientName: "…", quoteUrl: "…" } })</script>
//   <solar-calculator postcode="2487"></solar-calculator>
// ─────────────────────────────────────────────────────────────────────────

import { defineSolarCalculator, setGlobalConfig } from './element/solar-calculator.js';
import type { ClientConfig, ThemeTokens } from './config/schema.js';
import { themePresets } from './config/presets.js';

export interface SolarCalculatorGlobal {
  configure(config: ClientConfig): void;
  /** Ready-made theme token sets: SolarCalculator.presets.premium, etc. */
  presets: Record<'refined' | 'premium' | 'trust', ThemeTokens>;
  version: string;
}

const api: SolarCalculatorGlobal = {
  configure(config: ClientConfig): void {
    setGlobalConfig(config ?? {});
    // Re-resolve any already-mounted elements.
    document.querySelectorAll('solar-calculator').forEach((el) => {
      // Touch the property to trigger reconfigure without clobbering el.config.
      (el as unknown as { config: ClientConfig }).config =
        (el as unknown as { config: ClientConfig }).config ?? {};
    });
  },
  presets: themePresets,
  version: '0.1.0',
};

declare global {
  interface Window {
    SolarCalculator?: SolarCalculatorGlobal;
  }
}

if (typeof window !== 'undefined') {
  window.SolarCalculator = api;
}

defineSolarCalculator();

export default api;
